export default {
  siteName: 'Saffe Dashboard',
  siteIcon: 'ion-flash',
  footerText: `Saffe © ${new Date().getFullYear()}. All rights reserved.`,
  enableAnimatedRoute: false,
  apiUrl: 'https://d269gff3etwg2q.cloudfront.net/v0/',
  siteUrl: 'https://d269gff3etwg2q.cloudfront.net/',
  cdnUrl: 'https://d269gff3etwg2q.cloudfront.net/cdn/',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};
